import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Navbar from './components/Navbar'
import './Landing.scss'
import cuate from '../../assets/images/cuate.png'
import amico4 from '../../assets/images/amico4.png'
import HandCoding from '../../assets/images/hand-coding.png'
import { Icon } from '@iconify/react'
import FaqsData from '../../assets/data/FaqsData'
import Logo from '../../assets/images/logo-white.png'
import { Link as ScrollLink } from 'react-scroll'
import apiData from '../../assets/data/apiData'
import cards from '../../assets/data/cardsData'
import amico3 from '../../assets/images/amico3.png'
import wave from '../../assets/images/ph_waves-thin.png'
import token from '../../assets/images/token_dweb.png'
import { Link } from 'react-router-dom'

function Landing() {
  const navigate = useNavigate()
  const [selectedQuestion, setSelectedQuestion] = useState(0)

  const [currentSlide, setCurrentSlide] = useState(0)
  const [animating, setAnimating] = useState(false)

  const slides = [
    {
      title: 'Your business, powered by QC EXPRESS',
      description:
        'In a challenging logistics environment, our shipping integration solutions connect your business software with Qc Express logistic solutions. With modern APIs and a Shipment Visibility Webhook, you can automate shipping, track deliveries in real time, and streamline operations effortlessly, helping you navigate logistical challenges.',
      image: cuate,
    },
    {
      title: 'Get near real-time Shipment Visibility',
      description:
        'In a challenging logistics environment, our shipping integration solutions connect your business software with Qc Express logistic solutions. With modern APIs and a Shipment Visibility Webhook, you can automate shipping, track deliveries in real time, and streamline operations effortlessly, helping you navigate logistical challenges.',
      image: amico4,
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimating(true)
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length)
        setAnimating(false)
      }, 500)
    }, 5000)

    return () => clearInterval(interval)
  }, [slides.length])

  return (
    <div className='landing-page'>
      <Navbar usage='landing' />
      {/* <div className='hero'>
        <div className='hero-wrapper flex flex-wrap justify-between'>
          <div className='left'>
            <div className='left-wrap'>
              <h1 className='gradient-text'>Your business, powered by QC EXPRESS</h1>
              <p>
              In a challenging logistics environment, our shipping integration solutions connect your business software with Qc Express logistic solutions. With modern APIs and a Shipment Visibility Webhook, you can automate shipping, track deliveries in real time, and streamline operations effortlessly, helping you navigate logistical challenges.
              </p>
            </div>
            <div className='buttons'>
              <button onClick={() => navigate('/create-account')}>
                Get Started
              </button>
              <button onClick={() => navigate('/users/login')}>View Docs</button>
            </div>
          </div>
          <div className='right'>
            <img src={cuate} alt='programmer' />
          </div>
        </div>
      </div> */}

      <div className='hero'>
        <div className='hero-wrapper'>
          <div className={`slide ${animating ? 'fade-out' : 'fade-in'}`}>
            <div className='left'>
              <div className='left-wrap'>
                <h1 className='gradient-text'>{slides[currentSlide].title}</h1>
                <p>{slides[currentSlide].description}</p>
              </div>
              <div className='buttons'>
                <button onClick={() => navigate('/create-account')}>
                  Get Started
                </button>
                <button onClick={() => navigate('/login')}>View Docs</button>
              </div>
            </div>
            <div className='right'>
              <img src={slides[currentSlide].image} alt='hero' />
            </div>
          </div>
        </div>
      </div>

      <section className='integration'>
        <p>We’ve gathered some tools to help you get going with our API.</p>
        <h2>
          CREATE AND <span>INTEGRATE</span>
        </h2>
        <div className='cards-container'>
          {cards.map((card: any, index: number) => (
            <div className='card' key={index}>
              <Icon icon={card.icon} className='icon' />
              <h3>{card.title}</h3>
              <p>{card.content}</p>
              <img src={card.img} alt='card' />
            </div>
          ))}
        </div>
        <div className='get-started-btn'>
          <button
            className='get-started'
            onClick={() => navigate('/create-account')}
          >
            Get Started
          </button>
        </div>
      </section>

      <section className='solutions'>
        <h2 className='gradient-text'>
          No matter your business needs, our solutions keep your operations
          moving
        </h2>
        <p>
          QC Express APIs provide a fast, cost-effective solution to enhance
          your shipping process while keeping customers engaged.
        </p>

        <div className='solutions-content'>
          <div className='solutions-image'>
            <img src={HandCoding} alt='Developer Illustration' />
          </div>

          <div className='solutions-list'>
            <div className='solution-item'>
              <Icon
                icon='lineicons:certificate-badge-1'
                className='solution-icon'
              />
              <div>
                <h3>Streamlined Access to Resources</h3>
                <p>
                  Your business can quickly and efficiently connect to the
                  tools, data, and services you need. Leading to faster
                  operations, reduced downtime, and improved productivity. With
                  seamless integration, you can automate workflows, optimize
                  logistics, and enhance customer service.
                </p>
              </div>
            </div>

            <div className='solution-item'>
              <Icon
                icon='lineicons:certificate-badge-1'
                className='solution-icon'
              />
              <div>
                <h3>Improved Developer Productivity</h3>
                <p>
                  With our improved developer productivity, businesses enjoy
                  faster integration, reduced errors, and more efficient
                  software development. With well documented APIs and automation
                  tools, developers can quickly connect systems, streamline
                  workflows, and eliminate manual processes.
                </p>
              </div>
            </div>

            <div className='solution-item'>
              <Icon icon='stash:shield-duotone' className='solution-icon' />
              <div>
                <h3>Secure and Scalable Integration</h3>
                <p>
                  With our  secure and scalable integration, your systems stay
                  connected, protected, and ready to grow. Strong security keeps
                  sensitive data safe, while scalability ensures you can handle
                  more shipments, new carriers, and expanding operations without
                  slowdowns.
                </p>
              </div>
            </div>

            <div className='solution-item'>
              <Icon
                icon='clarity:group-solid-badged'
                className='solution-icon'
              />
              <div>
                <h3>Faster Time-to-Market</h3>
                <p>
                  A faster time-to-market ensures that your business meets
                  customer demands faster, reduces delays, and speeds up
                  deliveries by providing quicker deployment of new shipping
                  solutions, real-time tracking features, and system
                  integrations.
                </p>
              </div>
            </div>
          </div>
        </div>
        <button
          className='get-started'
          onClick={() => navigate('/create-account')}
        >
          Get Started
        </button>
      </section>

      <div className='api-listing-container'>
        <img src={wave} alt='wave' className='wave' />
        <p className='container-p'>API's</p>
        <h2 className='heading gradient-text'>
          EXPLORE QC EXPRESS API'S AND START UTILIZING THEM.
        </h2>
        <div className='api-grid'>
          {apiData.map((api: any, index: number) => (
            <div key={index} className='api-card'>
              <Icon icon={api.firstIcon} className='api-firstIcon' />
              <br />
              {api.title === 'Stats Dashboard' ? (
                <Icon icon='mdi:web' className='api-icon' />
              ) : (
                <Icon icon='mdi:api' className='api-icon' />
              )}

              <h3>{api.title}</h3>
              <p>{api.description}</p>
              {/* <div className='api-links'>
                <a href='#'>Overview</a>
                <a href='#'>Docs</a>
              </div> */}
            </div>
          ))}
        </div>
        <div className='bottom-img'>
          <img src={amico3} alt='' />
        </div>
      </div>

      <div className='blue-bg'></div>

      <section className='developer-portal-section'>
        <div className='container'>
          <h2 className='title gradient-text2'>WHY BUILD WITH US?</h2>
          <p className='description'>
            With years of experience serving B2B businesses, our mission is to
            help companies succeed by delivering reliable, efficient, and
            scalable logistics solutions. Nothing makes us more proud than
            seeing our clients achieve their goals, whether it's faster
            deliveries, optimized supply chains, or seamless global shipping.
            We've built our reputation on trust, innovation, and industry
            expertise, ensuring businesses have the support they need to grow.
          </p>

          <div className='card'>
            <div className='left'>
              <div className='icon' />
              <h3 className='portal-title'>DEVELOPER PORTAL</h3>
              <p className='sub-title'>QC EXPRESS</p>
              <p className='portal-description'>
                Develop on QC Express for free and gain hands-on experience with
                our APIs and Data Cloud. Test, integrate, and optimize logistics
                solutions without upfront costs.
              </p>
              <button className='start-button'>Start Building →</button>
            </div>

            <div className='right'>
              <h4>Features</h4>
              <ul className='features'>
                <li>
                  <Icon icon='icon-park-solid:check-one' className='' />{' '}
                  Integrate with anything using APIs.
                </li>
                <li>
                  <Icon icon='icon-park-solid:check-one' className='' /> Build
                  apps fast with drag-and-drop tools
                </li>
                <li>
                  <Icon icon='icon-park-solid:check-one' className='' /> Code
                  Samples
                </li>
                <li>
                  <Icon icon='icon-park-solid:check-one' className='' /> Testing
                  Environment (Sandbox)
                </li>
                <li>
                  <Icon icon='icon-park-solid:check-one' className='' />{' '}
                  Authentication and Keys
                </li>
              </ul>
            </div>
            <div className='laptop-illustration' />
          </div>
        </div>
        <img src={token} alt='' className='token' />
      </section>

      <div className='faqs'>
        <div className='wrapper'>
          <div className='top'>
            <h1 className='gradient-text'>frequently asked questions(FAQs)</h1>
            <p>
              Find answers to common inquiries in our Frequently Asked Questions
              (FAQ) section.
            </p>
          </div>
          <div className='faq-list'>
            {FaqsData.map((data, index) => (
              <div className='faq' key={index}>
                <div
                  className='question flex justify-between'
                  onClick={() => setSelectedQuestion(index)}
                >
                  <h3>{data.question}</h3>
                  <div>
                    {selectedQuestion === index ? (
                      <Icon icon='akar-icons:chevron-up' />
                    ) : (
                      <Icon icon='akar-icons:chevron-down' />
                    )}
                  </div>
                </div>
                {selectedQuestion === index && (
                  <div className='answer'>
                    <p>{data.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className='footer'>
        <div className='wrapper'>
          <div className='flex justify-between flex-wrap'>
            <div className='card logo'>
              <img src={Logo} alt='' />
              <p>
                Your trusted partner in getting goods where they need to be,
                fast and safe.
              </p>
              <div className='socials'>
                <a
                  href='https://www.instagram.com/qc_express?igsh=NjhyYWZtNm1lN3Rk'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon icon='akar-icons:instagram-fill' />
                </a>
                <Icon icon='akar-icons:facebook-fill' />
                <a
                  href='https://x.com/qc_express'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <Icon icon='akar-icons:twitter-fill' />
                </a>
              </div>
            </div>
            <div className='card'>
              <h3>Links</h3>
              <ul>
                {/* @ts-ignore */}
                <ScrollLink to='hero' smooth={true} duration={1000}>
                  <li>Home</li>
                </ScrollLink>
                {/* @ts-ignore */}
                <ScrollLink to='integration' smooth={true} duration={1000}>
                  <li>Integration</li>
                </ScrollLink>
                {/* @ts-ignore */}
                <ScrollLink to='solutions' smooth={true} duration={1000}>
                  <li>Solutions</li>
                </ScrollLink>
                {/* @ts-ignore */}
                <ScrollLink
                  to='api-listing-container'
                  smooth={true}
                  duration={1000}
                >
                  <li>APIs</li>
                </ScrollLink>
                {/* @ts-ignore */}
                <ScrollLink to='faqs' smooth={true} duration={1000}>
                  <li>FAQs</li>
                </ScrollLink>
              </ul>
            </div>
            <div className='card'>
              <h3>Support</h3>
              <ul>
                {/* @ts-ignore */}
                {/* <Link to='home' smooth={true} duration={1000}>
                  <li>FAQs</li>
                </Link> */}
                {/* @ts-ignore */}
                {/* <Link to='about-us' smooth={true} duration={1000}>
                  <li>Get in Touch</li>
                </Link> */}
                {/* @ts-ignore */}
                {/* <Link to='why-us' smooth={true} duration={1000}>
                  <li>Report a Security Issue</li>
                </Link> */}
                <Link to='/terms-and-conditions'>
                  <li>Terms of Services</li>
                </Link>
                <Link to='/privacy-policy'>
                  <li>Privacy</li>
                </Link>
              </ul>
            </div>
            <div className='card'>
              <h3>Contact Us</h3>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='mdi:location' />
                  </div>
                </div>
                <div className='text'>
                  <p>Location:</p>
                  <p>
                    14A Olatunji Close, Off Continental Way, Ikosi GRA IV,
                    Magodo, Lagos-Nigeria.
                  </p>
                </div>
              </div>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='ic:baseline-phone' />
                  </div>
                </div>
                <div className='text'>
                  <p>Phone Number:</p>
                  <p>
                    +234 912 049 9852–7, +234 802 0549 655, +234 802 290 2446
                  </p>
                </div>
              </div>
              <div className='flex'>
                <div>
                  <div className='icon'>
                    <Icon icon='bxs:envelope' />
                  </div>
                </div>
                <div className='text'>
                  <p>Email:</p>
                  <p>customercare@quartzclassic.com</p>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <p className='footer-p'>&copy; QC Express. All rights reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default Landing
